// The org that a node belongs to, and the caller's role in that org (G-1, app#385).
//
// ⚠⚠ THE NODE'S TENANT IS `nodes.owner_org_id`, NEVER THE ORG OF A NETWORK IT IS IN
// (docs/PERMISSIONS.md § 2 and § 6, router#1755). The two agree for most nodes. They part for a
// node provisioned into a network of another org, and later for a node in no network or in
// several. The router asks the tenant at every gate (PR router#1779), so a gate here that asks the
// ACTIVE org shows a control the router refuses, or hides one the router allows.
//
// Pure, so that `node --experimental-strip-types` can test it: the hook that uses it
// (`useOrgRole`) imports the organizations store, which pulls in zustand and supabase.

import type { OrgRole } from './orgRole.ts'

/**
 * The caller's role in `orgId`, read from the caller's own memberships.
 *
 * ⚠ Null when the caller is not a member of that org, and when `orgId` is not known. Null allows
 * nothing (`allows`), so an unknown tenant fails CLOSED: the control is hidden, never shown on a
 * guess.
 */
export const roleInOrg = (
  organizations: ReadonlyArray<{ id: string; role: string }>,
  orgId: string | null | undefined
): OrgRole => {
  if (!orgId) return null
  const role = organizations.find(o => o.id === orgId)?.role
  return role === 'owner' || role === 'admin' || role === 'member' ? role : null
}
